import { Reveal, Overline } from "./Reveal";

export const PageHero = ({ overline, title, titleItalic, text, testId }) => (
  <section className="relative overflow-hidden" data-testid={testId}>
    <div aria-hidden="true" className="absolute -top-24 -right-32 w-[30rem] h-[30rem] rounded-full bg-brand-mist/70 blur-3xl" />
    <div className="max-w-4xl mx-auto px-5 sm:px-8 pt-14 pb-10 sm:pt-20 sm:pb-14 relative">
      <Reveal>
        <Overline>{overline}</Overline>
        <h1 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.06] tracking-tight text-brand-ink">
          {title} {titleItalic && <span className="font-serif italic text-brand">{titleItalic}</span>}
        </h1>
        {text && <p className="mt-6 text-base sm:text-lg text-brand-muted leading-relaxed max-w-2xl">{text}</p>}
      </Reveal>
    </div>
  </section>
);
